<template>
  <div>
    <Breadcrumb msg1="商品库存" msg2="采购管理" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.purchase_no" placeholder="采购单号" clearable></el-input></el-col>
        <el-col :span="5">
          <el-select v-model="query.supplier_id" placeholder="供应商" clearable>
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="待收货" value="待收货"></el-option>
            <el-option label="已入库" value="已入库"></el-option>
            <el-option label="已取消" value="已取消"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新建采购单</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="采购单号" prop="purchaseNo" width="150"></el-table-column>
        <el-table-column label="供应商" width="160"><template slot-scope="scope">{{ supplierName(scope.row.supplierId) }}</template></el-table-column>
        <el-table-column label="金额" prop="totalAmount" width="100"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已入库' ? 'success' : (scope.row.status === '已取消' ? 'danger' : 'warning')">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="view(scope.row)">详情</el-button>
            <el-button size="mini" type="success" v-if="scope.row.status === '待收货'" @click="receive(scope.row)">收货入库</el-button>
            <el-button size="mini" type="danger" v-if="scope.row.status === '待收货'" @click="del(scope.row.id)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="800px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-form-item label="供应商" required>
          <el-select v-model="form.supplier_id" style="width: 100%">
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-divider content-position="left">采购明细</el-divider>
      <el-table :data="form.items" border size="small">
        <el-table-column label="SKU" width="220">
          <template slot-scope="scope">
            <el-select v-model="scope.row.skuId" size="mini" filterable style="width: 100%">
              <el-option v-for="sku in skus" :key="sku.id" :label="(sku.skuCode || '') + ' ' + (sku.specJson || '')" :value="sku.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="数量" width="110">
          <template slot-scope="scope"><el-input v-model.number="scope.row.quantity" size="mini" @change="calc(scope.row)"></el-input></template>
        </el-table-column>
        <el-table-column label="单价" width="110">
          <template slot-scope="scope"><el-input v-model.number="scope.row.price" size="mini" @change="calc(scope.row)"></el-input></template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">{{ scope.row.amount }}</template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="form.items.splice(scope.$index, 1)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button size="mini" icon="el-icon-plus" style="margin-top: 8px" @click="addItem">添加明细</el-button>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="采购单详情" :visible.sync="detailShow" width="700px">
      <el-descriptions :column="2" border size="small" v-if="detail.order">
        <el-descriptions-item label="采购单号">{{ detail.order.purchaseNo }}</el-descriptions-item>
        <el-descriptions-item label="供应商">{{ supplierName(detail.order.supplierId) }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ detail.order.status }}</el-descriptions-item>
        <el-descriptions-item label="金额">{{ detail.order.totalAmount }}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="detail.items" border size="small" style="margin-top: 10px">
        <el-table-column prop="skuId" label="SKU ID"></el-table-column>
        <el-table-column prop="quantity" label="数量"></el-table-column>
        <el-table-column prop="price" label="单价"></el-table-column>
        <el-table-column prop="amount" label="金额"></el-table-column>
      </el-table>
      <span slot="footer"><el-button @click="detailShow = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, purchase_no: '', supplier_id: null, status: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: { items: [] },
      detailShow: false,
      detail: { order: null, items: [] },
      suppliers: [],
      skus: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/suppliers', { params: { page: 1, limit: 200 } }).then(r => {
      if (r.data.status === 200) this.suppliers = r.data.data.records || []
    })
    this.$axios.http.get('/skus', { params: { page: 1, limit: 500 } }).then(r => {
      if (r.data.status === 200) this.skus = r.data.data.records || []
    })
  },
  methods: {
    supplierName (id) { const s = this.suppliers.find(x => x.id === id); return s ? s.name : '' },
    getData () {
      this.$axios.get('/purchaseOrders', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    addItem () { this.form.items.push({ skuId: null, quantity: 1, price: 0, amount: 0 }) },
    calc (row) { row.amount = ((row.quantity || 0) * (row.price || 0)).toFixed(2) },
    add () {
      this.dialogTitle = '新建采购单'
      this.form = { supplier_id: null, items: [] }
      this.addItem()
      this.show = true
    },
    save () {
      if (!this.form.supplier_id) { this.$message.warning('请选择供应商'); return }
      if (this.form.items.length === 0) { this.$message.warning('请至少添加一条明细'); return }
      this.$axios.post('/purchaseOrders', () => { this.show = false; this.getData() }, this.form)
    },
    receive (row) {
      this.$prompt('收货时间', '收货入库', { inputValue: this.now() }).then(({ value }) => {
        this.$axios.put(`/purchaseOrders/${row.id}/receive`, () => this.getData(), { arrive_time: value })
      }).catch(() => {})
    },
    del (id) {
      this.$axios.del(`/purchaseOrders/${id}`, () => this.getData())
    },
    view (row) {
      this.$axios.http.get(`/purchaseOrders/${row.id}`).then(r => {
        if (r.data.status === 200) {
          this.detail = { order: r.data.data.order, items: r.data.data.items || [] }
          this.detailShow = true
        }
      })
    },
    now () {
      const d = new Date()
      const p = n => (n < 10 ? '0' + n : '' + n)
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
    }
  }
}
</script>
